module.exports = __webpack_public_path__ + "img/IMG_9022_FoamcoreMatted.ca0da3a8.jpg";